<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'LegalDocumentPage',
};
</script>

<style>

</style>
